<template>
  <div class="row page-footer-banner">
    <div class="col page-footer-banner-button-area">
      <slot name="button-area"></slot>
    </div>
  </div>
</template>

<style scoped>
.page-footer-banner {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-top: 50px;
}
.page-footer-banner-button-area {
  text-align: center;
}
</style>
